module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section"
  }, [_c('h5', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f0ec7a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/protocol.vue
// module id = 234
// module chunks = 1